import React from "react";
import { Col, Divider, Modal, Row, Space, Tag, List, Typography, Tooltip } from "antd";
import {  PRINT_COLOR } from "../../constants/color";
import ColorButton from "../../common/ColorButton";
import { GET } from "../../frameworks/HttpClient";
import { URL_COMMON, URL_REPORT } from "../../constants/urls";
import AddListChemical from "../pond-latex/AddListChemical";
import ReportButton from "../common/ReportButton";
import _ from "lodash";
import { formatComma } from "../../frameworks/Util";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function LabAddChemicalHistoryModal(props) {
  const { open, target, onUpdate } = props;
  const { features } = useUserContext();
  const stockFeature = _.get(features, 'lab_input_stock_feature', false)
  const { Title } = Typography;

  return (
    <Modal
      open={open}
      onCancel={onUpdate}
      okText={"ยืนยัน"}
      cancelText={"ยกเลิก"}
      width={500}
      title={<Title level={5} style={{ margin : 4}}>ประวัติเติมสารเคมี</Title>}
      footer={
        <Space>
            {stockFeature && <ReportButton
              hideIcon={true} 
              url={`${URL_REPORT.LAB_INPUT_ORDER_ALL}${_.get(target ,'id', '')}/`}
              style={{ float : 'right'}}
              >
              พิมพ์รายการสั่งเติมสารเคมีทั้งหมด
            </ReportButton>}
          <ColorButton 
            override={PRINT_COLOR}
            style={{ float : 'right' }}
            onClick={onUpdate} 
          >
            ปิด
          </ColorButton>
        </Space>
      }
      destroyOnClose
    >
      {stockFeature && <>
      
        {target && target.inputs && target.inputs.map((items, index) => {
          return(
            <>
            <Tooltip title={'พิมพ์ใบสั่งเติม'}>
            <ReportButton 
              style={{ float : 'right' , marginTop : -6}}
              url={`${URL_REPORT.LAB_INPUT_ORDER}${items.id}`}
            ></ReportButton>
            </Tooltip>

            <div style={{ fontSize : 16, fontWeight : 'bolder', marginBottom : 8 }}>{items.chemical} <Tag color="orange" style={{  marginLeft : 10 }}>ปริมาณสั่งเติม : {formatComma(_.get(items, 'amount', '-'))}</Tag></div>

            <List
              bordered
              itemLayout="horizontal"
              dataSource={items.refs}
              style={{ padding : 0, marginBottom : 10}}
              renderItem={(item) => (
                  <>
                    <List.Item
                      style={{ padding: 6 }}
                    >
                      <List.Item.Meta
                        style={{ marginBottom : 0, marginTop : 5}}
                        title={
                        <>
                          <Row>
                            <Col span={14}>
                              <div style={{ marginLeft : 0 }}>{'ล็อตสารเคมี'} : {item.stock_ref_lot_no ? item.stock_ref_lot_no : ' - '}</div>
                            </Col>
                            <Col span={10} style={{ float : 'right'}}>
                              <div style={{ marginLeft : 0 }}>{'ปริมาณ'} : {item.amount}</div>
                            </Col>
                          </Row>
                        </>}
                      />
                    </List.Item>
                  </>
              )}
            />
            {(index !== _.size(target.inputs) - 1) &&  <Divider/> }
            </>
        )})}
      </>}
      {!stockFeature && <AddListChemical target={target} />}
    </Modal>
  )
}